import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';
import { withCancelToken } from '../../../queries/helpers/withCancelToken';

const fetcher = async (params, source) => {
  return request.get(
    '/FlatsGrid/available_step_address_life_cycle_by_address_id',
    params,
    undefined,
    'Error',
    undefined,
    undefined,
    { cancelToken: source.token },
    true
  );
};

const cancelableFetcher = (params) => {
  return withCancelToken((source) => fetcher(params, source));
};

const useRoomSteps = ({ addressId } = {}, options) => {
  return useQuery(
    getQueryKeys.roomSteps(addressId),
    () => cancelableFetcher({ addressId }),
    {
      enabled: Boolean(addressId),
      notifyOnChangeProps: 'tracked',
      ...options,
    }
  );
};

export { useRoomSteps };
